module.exports = __webpack_public_path__ + "static/media/fixing-button.0beeca1c.svg";